import React from 'react';
import { createRoot } from 'react-dom/client';
import { ReactTestComponent } from './ReactTestComponent';

console.log('Hello, React + Webpack + TypeScript!');

// Get the root element from the HTML
const container = document.getElementById('root');
if (!container) throw new Error("Root container not found");

// Create a React root and render the component
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ReactTestComponent />
  </React.StrictMode>
);
